import Listing from "../../Listing";
import React, { useEffect } from "react";
import Header from "../../../../layout/Header";
import Footer from "../../../../layout/Footer";
import { useDispatch, useSelector } from "react-redux";
import HeroSection from "../../../../layout/HeroSection";
import { pageRoutes } from "../../../../routes/pageRoutes";
import { fetchlessonPCBs } from "../../../../redux/action/lessonsAction";
import Loader from "../../../../components/other/Loader";
import SecureContent from "../../../../components/secureContent";

const PCBS = () => {
  const dispatch = useDispatch();
  const { pcbsList, isLoading } = useSelector((state) => state?.lessonsReducer);

  useEffect(() => {
    dispatch(fetchlessonPCBs());
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div>
      <SecureContent/>

        <Header />
        <HeroSection
          label={<h1 class="mb-3">{"PCBs"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Electrical engineering and robot combat",
              path: pageRoutes?.lessons?.electricalEngineering,
            },
            { name: "PCBs", path: `${pageRoutes?.home}/` },
          ]}
        />
        <Listing contentData={pcbsList} color={"#36296c"} />

        <Footer />
      </div>
    </>
  );
};

export default PCBS;
